import React from 'react';
import Input from '@/components/General/inputs/Input';

/**
 * Renders `text` and `longtext` schema fields. Reuses the shared `Input`,
 * enabling `multiline` for longtext. The Input component renders its own label,
 * required indicator, help-text tooltip, and clear button.
 */
const TextField = ({ field, value, onChange, disabled }) => {
    const isLongtext = field.type === 'longtext';
    const config = field.config || {};

    return (
        <Input
            testID={`form-field-${field.fieldId}`}
            title={field.label}
            placeholder={field.placeholder}
            value={value ?? ''}
            onUpdate={onChange}
            multiline={isLongtext}
            maxLength={config.maxLength}
            required={field.required}
            helpText={field.description}
            disabled={disabled}
            autoCapitalize="sentences"
        />
    );
};

export default TextField;
